import React from 'react';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { type SvgIconProps } from '@mui/material/SvgIcon';

interface Props extends SvgIconProps {
    showPassword: boolean;
}

export const PasswordVisibilityIcon = React.memo(({ showPassword, ...props }: Props) => {
    return showPassword ? <VisibilityOff {...props} /> : <Visibility {...props} />;
});
